import * as React from 'react';

import { CardSection, CardHeader, AddressLink } from '@europrocurement/flexy-components';
import { Box } from '@mui/material';
import { formatAddress } from '@europrocurement/l2d-utils';
import ClipboardLine from '../../../components/ClipboardLine';
import { PublisherTabProps } from './types';

const Contacts: React.FunctionComponent<PublisherTabProps> = function (props) {
    const { publisher } = props;

    const informationHeader = (
        <CardHeader
            title="Informations générales"
            border={false}
        />
    );

    const copyableLines: Array<{ label: string; value?: string | null }> = [
        {
            label: 'SIRET',
            value: publisher.siret,
        },
        {
            label: 'SIREN',
            value: publisher.siren,
        },
        {
            label: 'TVA Intracommunataire',
            value: publisher.tvaIntracommunautaire,
        },
    ];

    const mainAddress = formatAddress({
        firstLine: publisher.adresse1,
        secondLine: publisher.adresse2,
        zipCode: publisher.codePostal,
        city: publisher.ville,
    });

    return (
        <Box sx={{ paddingRight: '5px' }}>
            <CardSection header={informationHeader}>
                {mainAddress && (
                    <ClipboardLine
                        label="Adresse Principale"
                        value={<AddressLink address={mainAddress} />}
                        overridedValue={mainAddress}
                    />
                )}
                {copyableLines.map(({ label, value }, index) => {
                    const key = `publisher_contacts_infoline_${index}`;
                    return (
                        <ClipboardLine
                            key={key}
                            label={label}
                            value={value}
                        />
                    );
                })}
            </CardSection>
        </Box>
    );
};

export default Contacts;
